import React from "react";
import { StarIcon } from "lucide-react";
import { Section, SectionHeading } from "./Section";
import { CTAButton } from "./CTAButton";
import { testimonials } from "../data/testimonials";
export function Testimonials() {
  return <Section tone="cream" data-id="element-225" data-mp="3fy316196e265">
      <SectionHeading eyebrow="What professionals think" title="A Structured Approach to Continuing Professional Education" intro={["We believe that professional educational resources should be clear, organized, and relevant to the topics practitioners need to study."]} data-id="element-226" data-mp="3fxb2ghka7obn" />

      <div className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-227" data-mp="2x0jqyuazedi5">
        {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-white p-6 shadow-[0_14px_40px_-28px_rgba(10,26,51,0.6)]" data-id="element-228" data-mp="2s28h4jkos2zx">
            <div className="flex gap-0.5 text-gold-500" aria-label="5 out of 5 stars" data-id="element-229" data-mp="v8wsk7orfgbn">
              {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-current" aria-hidden data-id="element-230" data-mp="h5ya8j4cpl5q" data-mpi={i} />)}
            </div>
            <blockquote className="mt-4 text-[16px] leading-relaxed text-navy-900/85" data-id="element-231" data-mp="m5kkqkssonau">“{t.quote}”</blockquote>
            <figcaption className="mt-6 flex items-center gap-4 border-t border-navy-900/10 pt-5 md:mt-auto" data-id="element-232" data-mp="78k4pejyugs7">
              <img src={t.image} alt={t.name} className="h-14 w-14 shrink-0 rounded-full object-cover" loading="lazy" data-id="element-233" data-mp="c7wo1pbmp5q1" />
              <div data-id="element-234" data-mp="zwy1xs38d92p">
                <p className="font-bold text-navy-900" data-id="element-235" data-mp="zyiujc5zihxx">{t.name}</p>
                <p className="text-sm text-navy-900/65" data-id="element-236" data-mp="14u7ql5ispgph">
                  {t.role} · {t.country}
                </p>
              </div>
            </figcaption>
          </figure>)}
      </div>

      <CTAButton label="Explore the complete collection" note="One-time payment · $27 USD · Digital collection" data-id="element-237" data-mp="v4emepkzg3v9" />
    </Section>;
}